import { Autocomplete, AutocompleteProps, TextField } from '@mui/material';

type CustomOption = {
  value: string;
  label: string;
};

type CustomAutocompleteProps<OptionType> = {
  options: OptionType[];
  value: any;
  onChange: (newValue: string) => void;
  name?: string;
  label?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string;
} & Omit<
  AutocompleteProps<CustomOption, false, false, false>,
  'options' | 'value' | 'onChange' | 'renderInput'
>;

const CustomAutocomplete = <OptionType,>({
  options,
  value,
  onChange,
  name,
  label,
  required,
  error,
  helperText,
  ...otherProps
}: CustomAutocompleteProps<OptionType>) => {
  const parsedOptions: CustomOption[] = options?.map((option: any) => {
    if (option.value && option.label) {
      return { value: option.value, label: option.label };
    } else if (option.id && option.value) {
      return { value: option.id, label: option.value };
    }
    throw new Error('Invalid option format');
  });

  const selectedValue =
    parsedOptions?.find((option) => option.value === value) || null;

  return (
    <Autocomplete
      fullWidth
      options={parsedOptions}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      value={selectedValue}
      onChange={(_event, newValue) => {
        onChange(newValue?.value || '');
      }}
      {...otherProps}
      renderInput={(params) => (
        <TextField
          {...params}
          size={otherProps.size || params.size}
          name={name}
          label={label}
          fullWidth
          required={required}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export default CustomAutocomplete;
